import cn from 'classnames'
import { NoteLib, type NoteDegree as NoteDegreeType } from '@tunasong/music-lib'
import type { ChordFunction } from '@tunasong/models'
import type { FC, HTMLAttributes } from 'react'
import styles from './note-degree.module.css'

export interface NoteDegreeProps extends HTMLAttributes<HTMLSpanElement> {
  degree: NoteDegreeType
}

export const NoteDegree: FC<NoteDegreeProps> = ({ degree, style, className, ...restProps }) => (
  <span
    contentEditable={false}
    className={cn(styles.degree, className)}
    style={style}
    {...restProps}
  >
    {NoteLib.prettifyNote(degree)}
  </span>
)

export interface ChordDegreeProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * Functional label for a chord against an established scale, e.g. 'I', 'vi',
   * 'vii°', '♭VII', 'V/vi', 'chromatic'. Produced by `analyzeChord` in
   * `@tunasong/music-lib/analysis`. Already pretty (Unicode ♭ / °) — no
   * transformation needed.
   */
  chordFunction: ChordFunction
}

/**
 * Render a chord's functional label as a superscript, sharing styling with
 * `<NoteDegree>` for visual consistency. Distinct component so the prop type
 * stays narrow (chord-function labels are a separate union from note degrees).
 */
export const ChordDegree: FC<ChordDegreeProps> = ({ chordFunction, style, className, ...restProps }) => (
  <span
    contentEditable={false}
    className={cn(styles.degree, className)}
    style={style}
    {...restProps}
  >
    {chordFunction}
  </span>
)
